import {BreadcrumbType, Card} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {useRequiredParams} from 'shared/web';

import {EditGdprConsentTypeForm} from './components/EditGdprConsentTypeForm';

export function EditGdprConsentType() {
  const {id} = useRequiredParams();

  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('entity.gdpr.labels.gdprConsentTypes'),
      href: settingsRoutes.gdprConsentTypes,
    },
  ];

  return (
    <SettingsTemplate header={{breadcrumbs}} data-testid="edit-gdpr-consent-type-page">
      <Card title={i18n.t('page.settings.labels.editConsentType')}>
        <EditGdprConsentTypeForm cancelRoute={settingsRoutes.gdprConsentTypes} id={id} />
      </Card>
    </SettingsTemplate>
  );
}
